import { StyleSheet, View, TouchableOpacity, Text } from "react-native";

export function AdaptedButton({ handleClick, field, fieldValue, selected }) {
    const handleButtonClick = () => {
        handleClick(field, fieldValue);
    };
    return (
        <View>
            <TouchableOpacity
                style={[styles.button, selected ? styles.selectedButton : null]}
                onPress={handleButtonClick}
            >
                <Text style={styles.buttonText}>{fieldValue}</Text>
            </TouchableOpacity>
        </View>
    );
}


const styles = StyleSheet.create({
    button: {
        flex: 1,
        backgroundColor: '#EFE7DE',
        borderRadius: 10,
        borderWidth: 2,
        borderColor: '#EFE7DE',
        paddingVertical: 3,
        paddingHorizontal: 10,
        marginVertical: 3,
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      },
    selectedButton: {
        borderColor: '#3B1C15',
        flex: 1,
        backgroundColor: '#EFE7DE',
        borderRadius: 10,
        borderWidth: 2,
        paddingVertical: 3,
        paddingHorizontal: 10,
        marginVertical: 3,
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
        //backgroundColor: 'blue',
    },
    buttonText: {
        fontSize: '90%',
        textAlign: 'center',
        fontFamily:'DM Sans',
        color:'#351A16'
    },
})